import api from './api';

// ── Roles ─────────────────────────────────────────────────────────────────────
export const getRoles      = (category) => api.get('/roles', { params: { category } });
export const getCategories = () => api.get('/roles/categories');
export const getRole       = (slug) => api.get(`/roles/${slug}`);
export const getRoleProgress = (slug) => api.get(`/roles/${slug}/progress`);

// ── Questions ─────────────────────────────────────────────────────────────────
export const getSubChapterQuestions = (subChapterId) =>
  api.get(`/questions/sub-chapter/${subChapterId}`);
export const explainConcept = (questionId) =>
  api.post(`/questions/${questionId}/explain`);

// ── Answers ───────────────────────────────────────────────────────────────────
export const submitMCQ      = (data) => api.post('/answers/mcq', data);
export const submitWritten  = (data) => api.post('/answers/written', data);
export const submitSpoken   = (data) => api.post('/answers/spoken', data);
export const getImprovementPlan = (progressId) =>
  api.post('/answers/improvement-plan', { progress_id: progressId });

// ── Progress ──────────────────────────────────────────────────────────────────
export const startProgress    = (subChapterId) =>
  api.post('/progress/start', { sub_chapter_id: subChapterId });
export const completeProgress = (progressId) =>
  api.post('/progress/complete', { progress_id: progressId });
export const getResults       = (progressId) =>
  api.get(`/progress/results/${progressId}`);
export const getDashboardProgress = () => api.get('/progress/dashboard');
export const getStreak            = () => api.get('/progress/streak');

// ── Profile & Settings ────────────────────────────────────────────────────────
export const updateProfile    = (data) => api.put('/auth/profile', data);
export const changePassword   = (data) => api.post('/auth/change-password', data);

// ── Certificates ──────────────────────────────────────────────────────────────
export const getCertificates  = () => api.get('/certificates');

// ── JD Prep ───────────────────────────────────────────────────────────────────
export const getJDPrepSessions   = ()       => api.get('/jd-prep');
export const getJDPrepUsage      = ()       => api.get('/jd-prep/usage');
export const getJDPrepSession    = (id)     => api.get(`/jd-prep/${id}`);
export const generateJDPrep      = (data)   => api.post('/jd-prep/generate', data);
export const deleteJDPrepSession = (id)     => api.delete(`/jd-prep/${id}`);
export const getSavedCV            = ()           => api.get('/jd-prep/cv');
export const evaluateJDPrepAnswers = (id, answers) => api.post(`/jd-prep/${id}/evaluate-answers`, { answers });

// ── Study chapters ────────────────────────────────────────────────────────────
export const getStudyContent      = (subChapterId)          => api.get(`/study/${subChapterId}`);
export const markStudyComplete    = (subChapterId)          => api.post(`/study/${subChapterId}/complete`);
export const submitGateAnswers    = (subChapterId, answers) => api.post(`/study/${subChapterId}/gate`, { answers });

// ── Engagement ────────────────────────────────────────────────────────────────
export const getWeakSpots         = (roleId)                 => api.get(`/progress/weak-spots/${roleId}`);
export const getPercentile        = (subChapterId)           => api.get(`/progress/percentile/${subChapterId}`);
export const getDailyChallenge    = ()                       => api.get('/progress/daily-challenge');
export const completeDailyChallenge = (question_id, selected_index) =>
  api.post('/progress/daily-challenge/complete', { question_id, selected_index });
export const getMilestones        = (roleId)                 => api.get(`/progress/milestones/${roleId}`);
export const checkMilestones      = (role_id)                => api.post('/progress/milestones/check', { role_id });
export const getFeatureFlags      = ()                       => api.get('/system/features');

// ── Courses ────────────────────────────────────────────────────────────────────
export const getCourses          = (type)     => api.get('/courses', { params: type ? { type } : {} });
export const getCourse           = (slug)     => api.get(`/courses/${slug}`);
export const getCourseTopic      = (topicId)  => api.get(`/courses/topic/${topicId}`);
export const getMyEnrollments    = ()         => api.get('/courses/my-enrollments');
export const enrollCourse        = (courseId) => api.post(`/courses/${courseId}/enroll`);
export const getCourseForReader  = (courseId) => api.get(`/courses/learn/${courseId}`);
export const completeChapter     = (chapterId) => api.post(`/courses/chapter/${chapterId}/complete`);
export const updateCourseProgress = (courseId, topicId) => api.patch(`/courses/${courseId}/progress`, { topic_id: topicId });
